import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers/auth';
import router from "@/router";
import common from "@/composables/common";

export const useApiStore = defineStore({
    id: 'api',
    state: () => ({
        user: JSON.parse(localStorage.getItem('user')) ?? {token: null, hash:null, name: null},
        returnUrl: null
    }),
    getters: {
        isAuthorized() {
            const user = JSON.parse(localStorage.getItem('user'));
            return !!(user && user.token);
        }
    },
    actions: {
        async getStyleCard() {
                const api = await fetchWrapper.get('/stylecard/').catch(function (e){
                    console.log(e)
                });
                if (api) {
                    common.saveToLocalStorage("stylecard",api)
                    return api
                } else {
                    console.log('Error: api stylecard')
                    return {}
                }
        },
        async fetchImages() {
                const api = await fetchWrapper.get('/images/').catch(function (e){
                    console.log(e)
                });
                if (api) {
                    common.saveToLocalStorage("images",api)
                    return api
                } else {
                    console.log('Error: fetch api images')
                    return {}
                }
        },

        async onObrazEvent(event,value) {
                if (!this.isAuthorized) return {};
                const data = {
                    "event" : event,
                    "data": {
                        "obrazId": value
                    }
                }
                const api = await fetchWrapper.post('/events/',data).catch(function (e){
                    console.log(e)
                });
                if (api) {
                    common.saveToLocalStorage("events",api)
                    return api
                } else {
                    console.log('Error: fetch api events')
                    return {}
                }
        },

        async onStageEvent(event, value, first = null, fromPage = null) {
                if (!this.isAuthorized) return {};
                const data = {
                    "event" : event,
                    "data": {
                        "stage": value
                    }
                }
                if (first !== null) {
                    data.data.first = first;
                }
                if (fromPage !== null) {
                    data.data.from_page = fromPage;
                }
                try {
                    const api = await fetchWrapper.post('/events/',data);
                    return api
                } catch (error) {
                    return {}
                }
        },

        async onLookEvent(event,value) {
            if (!this.isAuthorized) return {};
            const data = {
                "event" : event,
                "data": {
                    "style": value
                }
            }
            const api = await fetchWrapper.post('/events/',data).catch(function (e){
                console.log(e)
            });
            if (api) {
                return api
            } else {
                return {}
            }
        },

        async commonEvent(event,data) {
            if (!this.isAuthorized) return;
            try {
                const payload = {
                    "event" : event,
                    "data": data
                }
                await fetchWrapper.post('/events/',payload);
            } catch (e) {

            }
        },

        async sendActivity(data) {
            if (!this.isAuthorized) return;
            try {
                const payload = {
                    "event": "onUserActivity",
                    "data": data
                };
                await fetchWrapper.post('/events/', payload);
            } catch (e) {
                // Игнорируем ошибки, чтобы не ломать процесс
            }
        },

        /** Отправка события onUserInteraction на эндпоинт POST /api/events/
         *  data: { delta_seconds, interactions: [ { page, numbers } ] }
         */
        async sendUserInteraction(data) {
            if (!this.isAuthorized) return;
            if (!data?.interactions?.length) return;
            try {
                const payload = {
                    event: 'onUserInteraction',
                    data
                };
                await fetchWrapper.post('/events/', payload);
            } catch (e) {
                // Игнорируем ошибки, чтобы не ломать процесс
            }
        },

        async getPreview() {
                const api = await fetchWrapper.get('/preview/').catch(function (e){
                    console.log(e)
                });
                if (api) {
                    common.saveToLocalStorage("preview",api)
                    return api
                } else {
                    console.log('Error: fetch api preview')
                    return {}
                }
        },

        async fetchCollection() {
                const api = await fetchWrapper.get('/collection/').catch(function (e){
                    console.log(e)
                });
                if (api) {
                    common.saveToLocalStorage("collection",api)
                    return api
                } else {
                    console.log('Error: fetch api collection')
                    return {}
                }
        },
        errorPage(){
            router.push('/error/505');
        }
    }
});